export const activities = [

  { value: "התעמלות אומנותית", label: "התעמלות אומנותית" },  
{ value: "כדורגל", label: "כדורגל" },
{ value: "כדורגל בנות", label: "כדורגל בנות" },
 // { value: "התעמלות אומנותית", label: "התעמלות אומנותית" },
  { value: "יוגה לילדים", label: "יוגה לילדים" },
  
  { value: "אומנויות ומלאכה", label: "אומנויות ומלאכה" },
  { value: "התעמלות קרקע ואקרובטיקה", label: "התעמלות קרקע ואקרובטיקה" },
  { value: "פינת החי מועדון", label: "פינת החי מועדון" },
  { value: "אקרו ברייקדאנס", label: "אקרו ברייקדאנס" },
  { value: "שחמט", label: "שחמט" },
  { value: "חוג מתמטיקה", label: "חוג מתמטיקה" },
  { value: "כדורעף", label: "כדורעף" },
  { value: "פינת חי", label: "פינת חי" },
  { value: "ג׳ודו", label: "ג׳ודו" },
  { value: "רובוטיקה", label: "רובוטיקה" },
  { value: "גומי קליי", label: "גומי קליי" },
  { value: "תפירה ועיצוב אופנה", label: "תפירה ועיצוב אופנה" },
  { value: "כלבנות ואילוף כלבים", label: "כלבנות ואילוף כלבים" },
  { value: "מבוכים ודרקונים", label: "מבוכים ודרקונים" },
 // { value: "אומנות ומלאכה", label: "אומנות ומלאכה" },
  { value: "סטודיו מיתרים", label: "סטודיו מיתרים" },
 // {
 //   value: "מצוינות בספורט עולים לג- דמי רישום",
 //   label: "מצוינות בספורט עולים לג- דמי רישום",
 // },
 // {
 //   value: "מצוינות בספורט עולים לד- דמי רישום",
 //   label: "מצוינות בספורט עולים לד- דמי רישום",
 // },
  { value: "אלקטרוניקה", label: "אלקטרוניקה" },
    { value: "רוגבי", label: "רוגבי" },

  {
    value: "תכשיטנות",
    label: "תכשיטנות"
  },
 // { value: "טאקוונדו", label: "טאקוונדו"},
  { value: "לגו מכאני", label: "לגו מכאני" },
  
  { value: "מצויינות בספורט", label: "מצויינות בספורט" }
  
  
  
  
  
  
  
  // { value: "כדוריד", label: "כדוריד" },
  // { value: "משקיעי העתיד", label: "משקיעי העתיד" },
  // { value: "מחשבים", label: "מחשבים" },
  // { value: "קרב מגע", label: "קרב מגע" },
  // { value: "חוג מחשבים קייטנת חנוכה", label: "חוג מחשבים קייטנת חנוכה" },
  // { value: "משקיעי העתיד", label: "משקיעי העתיד" },
  // { value: "נגרות", label: "נגרות" },
  // { value: "גומיקליי", label: "גומיקליי" },
  // { value: "חוג ציור בטכניקת פורינג", label: "חוג ציור בטכניקת פורינג" },
  // { value: "דמי רישום מצויינות בספורט", label: "דמי רישום מצויינות בספורט" },
  // {
    // { value: "פעילות סוכות", label: "פעילות סוכות" },
  // { value: "ברייקדאנס", label: "ברייקדאנס" },
    // { value: "הייטק וגימינג", label: "הייטק וגיימינג" },

     //   value: "מיניאטורות ציור ושילוב אומנויות",
    //   label: "מיניאטורות ציור ושילוב אומנויות",
    // },
    // { value: "ריקודי עם", label: "ריקודי עם" },
    // { value: "טיסנאות", label: "טיסנאות" },
    // { value: "בית הספר לקסמים", label: "בית הספר לקסמים" },
  // { value: "טריקינג", label: "טריקינג" },
  // { value: "חינוך פיננסי", label: "חינוך פיננסי" },
  // { value: "סייבר סקול", label: "סייבר סקול" },
  // { value: "בית הספר לקוסמים", label: "בית הספר לקוסמים" },
  // { value: "קרב מגע לילדים", label: "קרב מגע לילדים" },
  // { value: "רולר דאנס", label: "רולר דאנס" },
  // {value: "חקר המדע והרפואה", label: "חקר המדע והרפואה"},
  // {
  //   value: "מצוינות בספורט עולים לב- דמי רישום",
  //   label: "מצוינות בספורט עולים לב- דמי רישום",
  // },
 
  // {
  //   value: "מצוינות בספורט עולים לה- דמי רישום",
  //   label: "מצוינות בספורט עולים לה- דמי רישום",
  // },
  // {
  //   value: "מצוינות בספורט עולים לו- דמי רישום",
  //   label: "מצוינות בספורט עולים לו- דמי רישום",
  // },

  // { value: "אנגלית", label: "אנגלית" },
  // { value: "סדנא להגנה עצמית", label: "סדנא להגנה עצמית" },
  // { value: "צהרון 2023-2024", label: "צהרון 2023-2024" },
  // { value: "מצויינות קרקע ומכשירים", label: "מצויינות קרקע ומכשירים" },
  // { value: "תשלומי עמותה", label: "תשלומי עמותה" },
    // {
  //   value: "לינור ציור פורינג ומיקס מדיה באומנות",
  //   label: "לינור ציור פורינג ומיקס מדיה באומנות",
  // },
  // {
  //   value: "לינור תכשיטנות במקרמה וחרוזים",
  //   label: "לינור תכשיטנות במקרמה וחרוזים",
  // },
    // { value: "טאקוונדו", label: "טאקוונדו" },

    // { value: "יסמין בהרפתקאה במוזיאון", label: "יסמין בהרפתקאה במוזיאון" },
  // { value: "צהרון קיץ", label: "צהרון קיץ" },
  // { value: "משחק המלכים", label: "משחק המלכים" },
];
